module.exports = __webpack_public_path__ + "static/media/6.f0cbc2c6.png";